import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-terminos-ycondiciones-dialog",
  templateUrl: "./terminos-ycondiciones-dialog.component.html",
  styleUrls: ["./terminos-ycondiciones-dialog.component.scss"],
})
export class TerminosYCondicionesDialogComponent implements OnInit {
  public tc: any;
  aceptado = false;
  mostrarTexto = false;
  textoLeido = false;
  esPrimeraVez: boolean;
  url :  string

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<TerminosYCondicionesDialogComponent>,
  
  ) {}

  ngOnInit(): void {
    this.tc = this.data.tc;
    this.esPrimeraVez = this.data.primeraVez;
    this.url = this.tc.tipo_usuario + "/terminos-y-condiciones";

  }

  onLinkClick() {
    this.textoLeido = true;
  }

  aceptar() {
    this.dialogRef.close({ aceptado: true });
  }

  rechazar() {
    this.dialogRef.close({ aceptado: false });
  }
}
